import { AnyAction, combineReducers } from '@reduxjs/toolkit';
import flowsMetaDataSlice from '../slices/flowsMetaDataSlice';
import flowsSlice from '../slices/flowsSlice';

const appReducer = combineReducers({
  flows: flowsSlice,
  flowsMetaData: flowsMetaDataSlice,
});

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
const rootReducer = (
  state: ReturnType<typeof appReducer> | undefined,
  action: AnyAction,
) => {
  return appReducer(state, action);
};

export type RootState = ReturnType<typeof rootReducer>;

export default rootReducer;
